import React from 'react';

import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import { Icon } from 'components/icons/Icon';

interface BackToLoginLinkProps {
    onClick?: () => void;
}

export const BackToLoginLink = ({ onClick }: BackToLoginLinkProps) => (
    <Link
        to="/"
        onClick={onClick}
        className="tw-group tw-flex tw-items-center tw-gap-4 tw-text-primary tw-text-s tw-no-underline tw-mt-16"
    >
        <Icon icon="arrow-left" />
        <span className="group-hover:tw-underline">
            <FormattedMessage id="login.backToLogin" defaultMessage="Back to login" />
        </span>
    </Link>
);
